<template>
  <div>
    <h1>body bawah</h1>
  </div>
</template>

<script>
    export default {
        name: 'body_bawah',
            data () {
            return {
                msg: 'body bawah',
                apakah: 'Telasomu'
            }
        }
    }
</script>

<style>

</style>
